import SkorLogo from "../SkorLogo/SkorLogo";
import useTranslator from "../../../hooks/useTranslator";
import "./PoweredBySkor.css";

const PoweredBySkor = ({ className = "" }: { className?: string }) => {
  const { _t } = useTranslator();
  return (
    <span className={`ds-powered-by-skor ${className}`}>
      <span>{_t("poweredBy")}</span>
      <SkorLogo className="ds-powered-by-skor__logo" />
    </span>
  );
};
export default PoweredBySkor;
